export enum CompartmentEndpoint {
  Base = '/compartments',
  Overview = '/overview',
  Addresses = '/addresses',
  Available = '/available',
  Assigned = '/assigned',
  Users = '/users',
  Search = '/search',
  SsccId = '/ssccId',
  Rules = '/rules',
  Docks = '/docks',
  CarrierPermissions = '/carrier-permissions',
}
